/** Opções de React Query para a demo — evita refetch após seed do cache. */
export const TUTORIAL_DEMO_QUERY_OPTIONS = {
	staleTime: Number.POSITIVE_INFINITY,
	gcTime: Number.POSITIVE_INFINITY,
	refetchOnMount: false,
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
	refetchInterval: false,
} as const;
